export const getChatIdentity = (chat: {
  campaign_id: string;
  customer: { id: string };
}) => `${chat.campaign_id}+${chat.customer.id}`;

export const getCampaignIdFromChatIdentity = (identity: string) =>
  identity.split("+")[0];

export const getCustomerIdFromChatIdentity = (identity: string) =>
  identity.split("+")[1];
